import { authFetch, jsonFetch } from "utils";

export const get = (assetID) =>
  jsonFetch(`${apiUrl}${version}/assets/${assetID}/flyers`, {
    method: "GET",
  }).catch(() => {
    throw new Error();
  });

export const destroy = (flyerID) =>
  authFetch(`${apiUrl}${version}/flyers/${flyerID}`, { method: "DELETE" });

export const contact = (assetID, json) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/flyers/contact`, {
    method: "POST",
    json,
  });

export default get;
